import { useQuery } from "@tanstack/react-query";
import axios, { AxiosError } from "axios";
import { useNavigate } from "react-router-dom";

import { getAssets, getBalances } from "app/api/busha";
import { GenericErrorResponse } from "app/api/types";
import parseError from "app/lib/parseError";
import { BUSHA_ROOT } from "app/constants/routes";

export default function useGetBalances(bushaAuthToken: string) {
  const navigte = useNavigate();

  const { isLoading, error, refetch, data } = useQuery(
    ["balances"],
    () => getBalances(bushaAuthToken ?? ""),
    {
      onError: (error: AxiosError<GenericErrorResponse>) => {
        if (error.response?.status === 401) {
          navigte(BUSHA_ROOT, { replace: true });
        }
      },
      retry(failureCount, error) {
          if(axios.isAxiosError(error)) {
            return error.response?.status === 401 ? false : failureCount < 3;
          }
          return failureCount < 3;
      },
    }
  );

  return {
    isLoading,
    data: data?.data.data,
    refetch,
    error: error
      ? (parseError(error as AxiosError<GenericErrorResponse>) as string)
      : undefined,
  };
}
